import { useMutation } from "@tanstack/react-query";
import { postCreateHealthFacility } from "apis";
import queryClient from "../../../instances/react-query-client";
import { getMyProfileQueryKeys } from "../get-my-profile";

const usePostCreateHealthFacility = () => {
  return useMutation({
    mutationFn: postCreateHealthFacility,
    onSuccess: ({ success }) => {
      if (success) {
        queryClient.invalidateQueries(getMyProfileQueryKeys());
      }
    },
  });
};

export default usePostCreateHealthFacility;
